import Icon from "@mui/icons-material/ExpandMoreOutlined";
import { styled, Button as MuiButton } from "@mui/material";

export const Chevron = styled(Icon)(
  ({
    theme: {
      palette: { custom }
    }
  }) => `
    &.MuiSvgIcon-root {
      color: ${custom.white.main};
    }
  `
);

export const Button = styled(MuiButton)(
  ({
    theme: {
      palette: { custom },
      typography: { body2 }
    }
  }) => `
    &.MuiButton-root {
      background-color: ${custom.blue.main};
      border-radius: 8px;
      border: 2px solid ${custom.blue.light};
      font-size: ${body2.desktop.fontSize};
      font-weight: ${body2.desktop.fontWeight};
      line-height: ${body2.desktop.lineHeight};
      color: ${custom.white.main};
      padding: 10px 16px;
      text-transform: none;
    }
  `
);
